module.exports = __webpack_public_path__ + "static/michaela-Fun-86c7237fa638c3126d97e72f9b26a982.jpg";